import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const Nav = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-b border-[var(--bb-border)]"
          : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <div className="relative w-7 h-7 flex items-center justify-center">
            <div className="absolute inset-0 border border-[var(--bb-text)]/40 rotate-45" />
            <div className="absolute w-3 h-3 bg-[var(--bb-copper)] rotate-45" />
          </div>
          <span className="font-display tracking-[0.28em] text-[12px] text-[var(--bb-text)]">
            BLACK&nbsp;BELTS&nbsp;AI
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10 font-mono text-[11px] tracking-[0.24em] uppercase">
          <a href="#about" className="bb-link" data-testid="nav-link-about">
            Sobre Nosotros
          </a>
          <a href="#services" className="bb-link" data-testid="nav-link-services">
            Servicios
          </a>
          <a href="#contact" className="bb-link" data-testid="nav-link-contact">
            Contacto
          </a>
        </nav>

        <div className="hidden lg:block">
          <button
            type="button"
            onClick={onBook}
            className="bb-cta"
            data-testid="nav-cta"
          >
            <span>Agendar Reunión</span>
            <span aria-hidden>→</span>
          </button>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-[5px]"
          aria-label="menu"
          data-testid="nav-mobile-toggle"
        >
          <span
            className={`block w-5 h-px bg-[var(--bb-text)] transition-transform ${
              open ? "translate-y-[3px] rotate-45" : ""
            }`}
          />
          <span
            className={`block w-5 h-px bg-[var(--bb-text)] transition-transform ${
              open ? "-translate-y-[3px] -rotate-45" : ""
            }`}
          />
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[var(--bb-bg-2)] border-t border-[var(--bb-border)]">
          <div className="flex flex-col px-6 py-8 gap-6 font-mono text-[12px] tracking-[0.24em] uppercase">
            <a href="#about" onClick={() => setOpen(false)}>
              Sobre Nosotros
            </a>
            <a href="#services" onClick={() => setOpen(false)}>
              Servicios
            </a>
            <a href="#contact" onClick={() => setOpen(false)}>
              Contacto
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
};
